<template>
  <div :class="{disabled}">
    <datepicker
      :value="selectedDates"
      @input="onChange"
      :config="datepickerOptions"
      readonly
      :placeholder="placeholder || 'All dates'"
      ref="datepicker"
      :key="`dp-${id}`"
    >
      <div class="icon">
        <i v-if="!icon" class="material-icons">event</i>
        <img v-if="icon === 'plus'" src="~@/assets/icons/add.svg" />
      </div>
      <img
        class="clear"
        v-if="show_clear"
        src="~@/assets/icons/clear.svg"
        @click.stop.prevent="clear()"
      />
    </datepicker>
  </div>
</template>

<script>
import Datepicker from 'vue-bulma-datepicker';
import moment from 'moment';

export default {
  name: 'Datepicker',
  data() {
    return {
      datepickerOptions: {
        wrap: true,
        mode: this.mode,
        dateFormat: 'j M Y',
        maxDate: this.maxDate,
        minDate: this.minDate,
        prevArrow: `<i class='material-icons'>chevron_left</i>`,
        nextArrow: `<i class='material-icons'>chevron_right</i>`,
        locale: {
          weekdays: {
            shorthand: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
          },
        },
      },
    };
  },
  props: {
    mode: String,
    value: [String, Date],
    onChange: Function,
    placeholder: String,
    icon: String,
    minDate: {
      type: Date,
      default: null,
    },
    maxDate: {
      type: Date,
      default: null,
    },
    id: [String, Number],
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clear() {
      this.onChange(null);
    },
  },
  computed: {
    show_clear() {
      let required_length = 6;
      if (this.mode === 'range') {
        required_length = 15;
      }
      return this.selectedDates && this.selectedDates.length > required_length;
    },
    selectedDates() {
      const dates = this.value
        ? typeof this.value !== 'string'
          ? moment(this.value).format('DD MMM YYYY')
          : this.value
        : null;
      return dates;
    },
  },
  components: {
    datepicker: Datepicker,
  },
  watch: {
    selectedDates(val) {
      // vue-bulma-datepicker has a bug where it can't be cleared once a date is set.
      // This runs it's internal method for setting dates and clears the field.
      if (!val) {
        this.$nextTick(() => {
          this.$refs['datepicker'].dateUpdated('', null);
          this.$refs['datepicker'].datepicker.clear();
        });
      }
    },
    minDate(newValue) {
      this.datepickerOptions.minDate = newValue;
      if (
        this.$refs &&
        this.$refs.datepicker &&
        this.$refs.datepicker.datepicker
      ) {
        this.$refs.datepicker.datepicker.set('minDate', newValue);
      }
    },
    maxDate(newValue) {
      this.datepickerOptions.maxDate = newValue;
      if (
        this.$refs &&
        this.$refs.datepicker &&
        this.$refs.datepicker.datepicker
      ) {
        this.$refs.datepicker.datepicker.set('maxDate', newValue);
      }
    },
  },
};
</script>
<style scoped>
  .disabled {
    pointer-events: none;
    opacity: 0.7;
  }
</style>
